import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset window scroll on route changes. Hash-only updates are left alone so
 * Home can scroll to #engine / #pricing without fighting this effect.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}
